<template>
  <div class="zjsLevel2">
      <el-tag style="font-size: 16px;">激活中金所Level-2</el-tag><br/><br/>
      <el-form :inline="true"  class="demo-form-inline">
        <el-form-item label="账号：">
          <el-input v-model="account" placeholder="账号"></el-input>
        </el-form-item>
        <el-form-item label="密码：" >
          <el-input v-model="password" placeholder="密码" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" :disabled = "isDisabled">确认</el-button>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
        account: '',
        password: '',
        isDisabled: false,
    };
  },
  created() {
    document.title = "激活中金所Level-2";
  },
  methods: {
    onSubmit() {
      this.isDisabled = true
      var params = {
        account: this.account,
        password: this.password
      };
      this.$post("/client/v1/zjsl2Active", params)
        .then(response => {
          if (response.code === 0) {
            alert("中金所Level-2权限激活完毕，您需要退出软件重新登录。");
          } else {
            alert(response.msg);
            // 可以点
            this.isDisabled = false
          }
        })
        .catch(err => {
          // 可以点
          this.isDisabled = false
          alert("网络异常，请稍后重试");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.zjsLevel2{
  width: 100%;
  height: 100vh;
  background: #000;
  >>> .el-form-item__label{
    color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/client/Zjsl2Active.vue